import { ConsentContextType } from '../model';
import { createContext } from 'react';

const ConsentContext = createContext<ConsentContextType | null>(null);

export default ConsentContext;
